import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BusinessDomainOwner } from './models/business-domain-owner.model';

@Injectable({
    providedIn: 'root',
})
export class BusinessDomainOwnersService {
    public constructor(private readonly httpClient: HttpClient) {}

    public getBusinessDomainOwners(businessDomainId: string): Observable<BusinessDomainOwner[]> {
        return this.httpClient.get<BusinessDomainOwner[]>(`business-domains/${businessDomainId}/owners`);
    }

    public addBusinessDomainOwner(businessDomainId: string, ownerId: string): Observable<unknown> {
        const body = null;
        return this.httpClient.post<unknown>(`business-domains/${businessDomainId}/owners/${ownerId}`, body);
    }

    public removeBusinessDomainOwner(businessDomainId: string, ownerId: string): Observable<unknown> {
        return this.httpClient.delete<unknown>(`business-domains/${businessDomainId}/owners/${ownerId}`);
    }
}
